import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fallback static data for categories and types
export const categories = [
  { id: 'all', name: { ja: 'すべて', en: 'All', pt: 'Todos', id: 'Semua', vi: 'Tất cả', es: 'Todos', tl: 'Lahat' } },
  { id: 'forklift', name: { ja: 'フォークリフト', en: 'Forklift', pt: 'Empilhadeira', id: 'Forklift', vi: 'Xe nâng', es: 'Montacargas', tl: 'Forklift' } },
  { id: 'construction', name: { ja: '建設機械', en: 'Construction', pt: 'Construção', id: 'Konstruksi', vi: 'Xây dựng', es: 'Construcción', tl: 'Konstruksyon' } },
  { id: 'crane', name: { ja: 'クレーン・玉掛け', en: 'Crane & Slinging', pt: 'Guindaste', id: 'Crane', vi: 'Cần cẩu', es: 'Grúa', tl: 'Crane' } },
  { id: 'safety', name: { ja: '安全衛生', en: 'Safety & Health', pt: 'Segurança', id: 'Keselamatan', vi: 'An toàn', es: 'Seguridad', tl: 'Kaligtasan' } },
  { id: 'other', name: { ja: 'その他', en: 'Other', pt: 'Outros', id: 'Lainnya', vi: 'Khác', es: 'Otros', tl: 'Iba pa' } },
];

export const types = [
  { id: 'all', name: { ja: 'すべて', en: 'All', pt: 'Todos', id: 'Semua', vi: 'Tất cả', es: 'Todos', tl: 'Lahat' } },
  { id: 'skill', name: { ja: '技能講習', en: 'Skill Training', pt: 'Treinamento', id: 'Pelatihan Keterampilan', vi: 'Đào tạo kỹ năng', es: 'Capacitación', tl: 'Pagsasanay sa Kasanayan' } },
  { id: 'special', name: { ja: '特別教育', en: 'Special Education', pt: 'Educação Especial', id: 'Pendidikan Khusus', vi: 'Giáo dục đặc biệt', es: 'Educación Especial', tl: 'Espesyal na Edukasyon' } },
];

export function useCourses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCourses = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API}/courses`);
      setCourses(response.data || []);
    } catch (err) {
      console.error('Error fetching courses:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses]);

  const getCourseById = useCallback((id) => {
    return courses.find(course => course.id === id);
  }, [courses]);

  const getCoursesByCategory = useCallback((category) => {
    return category === 'all' ? courses : courses.filter(course => course.category === category);
  }, [courses]);

  const getCoursesByType = useCallback((type) => {
    return type === 'all' ? courses : courses.filter(course => course.type === type);
  }, [courses]);

  const getFeaturedCourses = useCallback(() => {
    return courses.filter(course => course.featured);
  }, [courses]);

  const getFilteredCourses = useCallback((category, type) => {
    return courses.filter(course => {
      const categoryMatch = category === 'all' || course.category === category;
      const typeMatch = type === 'all' || course.type === type;
      return categoryMatch && typeMatch;
    });
  }, [courses]);

  return {
    courses,
    loading,
    error,
    fetchCourses,
    getCourseById,
    getCoursesByCategory,
    getCoursesByType,
    getFeaturedCourses,
    getFilteredCourses,
    categories,
    types
  };
}

export default useCourses;
